import { request } from '../utils/request';

const getPgStandardFields = () => request.get('/custom-fields/standard');

export default getPgStandardFields;
